import { ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AtButtonDirective, AtIconComponent, ConfigurableAuthService } from '@anothertrip/anothertrip-ds';

@Component({
  selector: 'app-page-not-found',
  imports: [AtIconComponent, AtButtonDirective, RouterLink],
  templateUrl: './page-not-found.page.html',
  styleUrl: './page-not-found.page.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageNotFoundPage {
  private readonly authService = inject(ConfigurableAuthService);

  protected readonly isLoggedIn = this.authService.isLoggedIn;

  /** Signed in, home is the Home page (`/dashboard`); signed out, it is the public start page. */
  protected readonly homeUrl = computed<string>(() => (this.isLoggedIn() ? '/dashboard' : '/'));
}
